export default function MySQL_FOREIGNKEY() {
  return (
    <div>
      <h2>MySQL_FOREIGNKEY</h2>    </div>
  );
}